module.exports = __webpack_public_path__ + "static/sinead-slideshow-01@2x-38637979cac757e8ffc23c0dddee6e88.jpg";